const locale = {
    placeholder: 'VÃ¦lg tid',
  };
  
  export default locale;
  